export default __webpack_public_path__ + "BoxBlockLine.svg?3c627d5d89f825c28e93c7be4fb08bdf";